import HomeContent from "./home-content";
import Footer from "./footer";
import Loading from "./loading";
import NavBar from "./nav-bar";
import MenuContentCW from "./menu-content-cw.component";
import MenuContentNW from "./menu-content-nw.component"

export { HomeContent, Footer, Loading, NavBar, MenuContentCW, MenuContentNW};
